import { ModalSpace, useModal } from 'src/provider/ModalContextProvider'
import ModalView from 'src/components/common/Modal/view'
import { useBlocker } from 'react-router-dom'
import React, { useEffect } from 'react'
import useLockBodyScroll from 'src/hooks/useLockBodyScroll.hook'
import { useChannel } from 'src/provider/ChannelContextProvider'
import RenderIf from 'src/components/common/RenderIf'

export interface ModalProps {
  modalData: ModalSpace.ModalData
  onCancelInternal: () => void
  onSubmitInternal: () => void
}

const Modal = () => {
  const { isOpen, closeModal, modalData } = useModal()
  const { ios } = useChannel()
  const { type = 'default', contents, button } = modalData
  const block = useBlocker(isOpen && !ios)

  const onCancelInternal = () => {
    closeModal().then(() => {
      block.state === 'blocked' && block.reset()
      button?.cancel?.f?.()
    })
  }

  const onSubmitInternal = () => {
    closeModal().then(() => {
      block.state === 'blocked' && block.reset()
      button?.submit?.f?.()
    })
  }

  const popStateHandler = () => {
    closeModal().then(() => {
      block.state === 'blocked' && block.reset()
      !!button?.cancel?.t ? button?.cancel?.f?.() : button?.submit?.f?.()
    })
  }

  useLockBodyScroll(isOpen)

  useEffect(() => {
    window.addEventListener('popstate', popStateHandler)
    return () => {
      window.removeEventListener('popstate', popStateHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isOpen) {
      block.state === 'blocked' && block.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const props: ModalProps = {
    modalData,
    onCancelInternal,
    onSubmitInternal,
  }

  return (
    <React.Fragment>
      <RenderIf when={type === 'default'}>
        <ModalView {...props} />
      </RenderIf>
      <RenderIf when={type === 'custom'}>{contents?.children}</RenderIf>
    </React.Fragment>
  )
}

export default Modal
